import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enParent from '@/locales/en/parent.json';
import enCommon from '@/locales/en/common.json';
import enNotifications from '@/locales/en/notifications.json';
import esParent from '@/locales/es/parent.json';
import esCommon from '@/locales/es/common.json';
import esNotifications from '@/locales/es/notifications.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { parent: enParent, common: enCommon, notifications: enNotifications },
      es: { parent: esParent, common: esCommon, notifications: esNotifications },
    },
    fallbackLng: 'en',
    defaultNS: 'parent',
    ns: ['parent', 'common', 'notifications'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
